import * as Yup from "yup";
import { Form, FormikProvider, FieldArray, useFormik } from "formik";
import { Modal } from "antd";
import {
  Box,
  Grid,
  Button,
  InputAdornment,
  Paper,
  Avatar,
  TextField
} from "@material-ui/core";
// import ItemAutoComplete from './../../shared/components/ItemAutoComplete';
// import AUTO_COMPLET_TYPE from './../../shared/constants/autoCompleteType';
import ItemsAutoComplete from './../_customs/ItemsAutoComplete';
import { firestore } from "../../config/firebaseConfig";

const VendorNotFound = 'Not-found';

export default function ItemsWithVendorModal({
  visible,
  handleCancel,
  vendor
}) {
  // console.log(vendor)

  const formSchema = Yup.object().shape({});
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      Prices: []
    },
    validationSchema: formSchema,
    onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
      try {

        //console.log("jnjn" + JSON.stringify(values));
        // console.log("vendor" + JSON.stringify(vendor));
        

        values.Prices.forEach(item => {

          let itemsRef = firestore.collection('items').doc(item.itemId)
          // console.log(item)
          // console.log("vendor" + JSON.stringify(itemsRef));
          // console.log("vendor" + JSON.stringify(itemsRef));
          //   itemsRef.get().then((doc) => { 
          //     console.log("vendor 0" + JSON.stringify(itemsRef.Vendors));
          //     console.log("Cached document data:", doc.data());
          //     let resultItem = { id: doc.id, ...doc.data() }
          //     console.log(resultItem.Vendors)
          //     if (resultItem.Vendors[vendor.id] === undefined) {

          //       let resultItem = { id: doc.id, ...doc.data() }

          //       resultItem.Vendors[vendor.id] = resultItem

          //     }else {
          //       console.log(false)

          //     }
          // })

          itemsRef.get().then((doc) => {
            if (doc.exists) {
              let resultItem = { id: doc.id, ...doc.data() }

              let vendorInfo = resultItem.Vendors && resultItem.Vendors[`${vendor.id}`] ? resultItem.Vendors[`${vendor.id}`] : VendorNotFound

              if (vendorInfo && vendorInfo !== VendorNotFound) { 
                if (vendorInfo === VendorNotFound) { 
                  let newVendor = { Name: vendor.Name, ItemCode: item.itemCode, Prices: [{ Price: Number(item.Price), ItemCode: item.itemCode, UpdateAt: new Date() }] }
                  resultItem.Vendors[`${vendor.id}`] = newVendor;

                  return;
                } 
                var result = resultItem.Vendors[`${vendor.id}`].Prices.find((p => p.Price === Number(item.Price)))
                resultItem.Vendors[`${vendor.id}`].ItemCode = item.itemCode
                // console.log('result'+ JSON.stringify(result)) 

                if (result !== null && result !== undefined) { 
                  result.UpdateAt = new Date()
                } else { 
                  if (resultItem.Vendors[`${vendor.id}`].Prices.length < 5) { 
                    resultItem.Vendors[`${vendor.id}`].ItemCode = item.itemCode
                    resultItem.Vendors[`${vendor.id}`].Prices.push({ Price: Number(item.Price), ItemCode: item.itemCode, UpdateAt: new Date() });
                     
                  } else { 
                    // resultItem.Vendors[`${vendor.id}`].Prices.push({Price:  Number(item.Price), UpdateAt: new Date()}) 
                    var ordonPrice = resultItem.Vendors[`${vendor.id}`].Prices.sort((a, b) => {
                      if (a.UpdateAt < b.UpdateAt) {
                        return 1;
                      }
                      if (a.UpdateAt > b.UpdateAt) {
                        return -1;
                      }
                      return 0;
                    })

                    //console.log(ordonPrice); 
                    ordonPrice.unshift({ Price: Number(item.Price), ItemCode: item.itemCode, UpdateAt: new Date() });
                    var restArray = ordonPrice.slice(0, 5);
                    resultItem.Vendors[`${vendor.id}`].ItemCode = item.itemCode
                    resultItem.Vendors[`${vendor.id}`].Prices = restArray;
                    //console.log(restArray)
                  }
                }



              } else {
 
                let newVendor = { Name: vendor.Name, ItemCode: item.itemCode, Prices: [{ Price: Number(item.Price), ItemCode: item.itemCode, UpdateAt: new Date() }] }
                let sVendors = {}
                //onsole.log(sVendors)

                if (resultItem?.Vendors === null || resultItem?.Vendors === undefined) {
                  //sVendors = newVendor;
                  sVendors[`${vendor.id}`] = newVendor;
                  resultItem = {  ...resultItem, Vendors: sVendors }
                  //console.log(resultItem)
                } else {

                  sVendors[`${vendor.id}`] = newVendor;
                  resultItem.Vendors[`${vendor.id}`] = newVendor;
                  //console.log('resultItem last updated' + JSON.stringify(resultItem.Vendors))
                }



              }

              doc.ref.update(resultItem);
              // console.log(resultItem)
            }
          })

        });
        setSubmitting(false);
        resetForm();
      } catch (error) {
        setSubmitting(false);
        setErrors(error);
      }
    },
  });


  const { values, isSubmitting, handleSubmit, getFieldProps, setFieldValue } = formik;


  const handleChange = (newValues) => {  
    const items = newValues.map(item => { return { itemId: item.id, itemCode: item.itemCode, itemName: item.name, imageUrl: item.imageUrl, Price: 0 } });
    setFieldValue('Prices', items);

  }


  return (
    <Modal
      title=" La liste des Produits selectionnées et le Prix "
      visible={visible}
      footer={[]}
      confirmLoading={isSubmitting}
      onCancel={handleCancel}
      width={700}
    >
      <>
        <Box style={{ marginTop: 10 }}>
          {/* <ItemAutoComplete type={AUTO_COMPLET_TYPE.multiple} size="small" onChange={handleChange} /> */}
          <ItemsAutoComplete
            multiple
            size={'small'}
            onChange={handleChange}
            minWidth={400}
          />
        </Box>
        <Box style={{ marginTop: 20 }}>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Grid container item spacing={2} justify='flex-end'>

              </Grid>

              <FieldArray
                name="Prices"
                render={arrayH => (
                  <>
                    {values.Prices.map((price, idx) => (
                      <Paper key={idx} variant="outlined" style={{ width: '100%', padding: 5 }}>
                        <Grid container spacing={1}>
                          <Grid item xs={1}>
                            <Avatar alt="" src={price.imageUrl} style={{ width: 35, height: 35 }} />
                          </Grid>
                          <Grid item xs={7}>
                            <TextField
                              label="Nom"
                              fullWidth
                              variant="outlined"
                              margin="dense"
                              {...getFieldProps(`Prices.${idx}.itemName`)}
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <TextField
                              label="Code"
                              fullWidth

                              variant="outlined"
                              margin="dense"
                              {...getFieldProps(`Prices.${idx}.itemCode`)}
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <TextField
                              label="Prix"
                              variant="outlined"
                              margin="dense"
                              type="integer"
                              min={0}
                              max={100}
                              {...getFieldProps(`Prices.${idx}.Price`)}
                              InputProps={{
                                startAdornment: <InputAdornment position="start">$</InputAdornment>,
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Paper>
                    ))}
                  </>
                )}
              />
              <Grid item container justify="flex-end" style={{ marginTop: 10 }} >
                <Button
                  variant="contained"
                  color='primary'
                  type="submit"
                  size="small"
                  onClick={handleCancel}>
                  Valider
                </Button>
              </Grid>

            </Form>
          </FormikProvider>
        </Box>

      </>

    </Modal>
  );
}
